// src/utils/groupsStorage.js

const GROUPS_KEY = 'mojo_contribution_groups_v1'

const safeParse = (raw, fallback) => {
    try {
        const parsed = JSON.parse(raw)
        return parsed ?? fallback
    } catch {
        return fallback
    }
}

export const loadGroups = () => {
    const raw = localStorage.getItem(GROUPS_KEY)
    const arr = raw ? safeParse(raw, []) : []
    return Array.isArray(arr) ? arr : []
}

export const saveGroups = (groups) => {
    localStorage.setItem(GROUPS_KEY, JSON.stringify(groups))
}

export const getGroupById = (groupId) => {
    const groups = loadGroups()
    return groups.find((g) => g.id === groupId) || null
}

export const upsertGroup = (group) => {
    const groups = loadGroups()
    const idx = groups.findIndex((g) => g.id === group.id)
    const next = idx >= 0 ? groups.map((g, i) => (i === idx ? group : g)) : [group, ...groups]
    saveGroups(next)
    return group
}

/**
 * ✅ Default export included to avoid “possible exports: default” errors
 * if any file imports groupsStorage as default somewhere else.
 */
const groupsStorage = {
    loadGroups,
    saveGroups,
    getGroupById,
    upsertGroup,
}

export default groupsStorage
